<template>
  <Teleport to="body">
    <div class="howto-backdrop" @click.self="$emit('close')">
      <div class="howto guide" role="dialog" aria-modal="true" :aria-label="guide.title">
        <button class="howto__close icon-button" aria-label="Close" @click="$emit('close')">×</button>
        <div class="howto__body">
          <h3 :style="{ '--role': colour }">{{ guide.title }}</h3>
          <p class="guide__intro">{{ guide.intro }}</p>
          <section v-for="sec in sections" :key="sec.key" class="guide__section">
            <h4>{{ sec.title }}</h4>
            <ul v-if="sec.key !== 'words'">
              <li v-for="(line, i) in sec.lines" :key="i">{{ line }}</li>
            </ul>
            <dl v-else class="guide__words">
              <template v-for="([term, text]) in sec.lines" :key="term">
                <dt>{{ term }}</dt>
                <dd>{{ text }}</dd>
              </template>
            </dl>
          </section>
        </div>
        <div class="howto__nav">
          <span class="howto__dots" />
          <button class="primary howto__next" @click="$emit('close')">Got it</button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { GUIDES } from '@/guides';
import { ROLE_INFO } from '@/engine/constants';

// The role's own how-to, on the phone, any time.
export default {
  name: 'RoleGuide',
  props: { role: { type: String, required: true } },
  emits: ['close'],
  computed: {
    guide() { return GUIDES[this.role] || { title: 'How to play', intro: '', day: [], gives: [], needs: [], words: [] }; },
    colour() { return ROLE_INFO[this.role]?.colour; },
    sections() {
      return [
        { key: 'day', title: 'Your day, step by step', lines: this.guide.day },
        { key: 'gives', title: 'What you give the others', lines: this.guide.gives },
        { key: 'needs', title: 'What you need from them', lines: this.guide.needs },
        { key: 'words', title: 'Words on your screen', lines: this.guide.words },
      ];
    },
  },
};
</script>
